export default __webpack_public_path__ + "static/media/frg--castle-hill.ec34dee3.png";